import type { Permission } from '@immo/api-contract';
import { apiClient } from './api-client';

/** Loads the caller's effective org-scoped grants for the addressed Standort. */
export async function fetchMemberPermissions(organizationId: string): Promise<ReadonlyArray<Permission>> {
  const result = await apiClient.organizations.getMyPermissions({ pathParams: { organizationId } });

  if (!result.ok) {
    throw new Response('Failed to load member permissions', { status: result.status });
  }

  return result.body.permissions as ReadonlyArray<Permission>;
}
